import { useEffect, type RefObject } from 'react';

/**
 * Keep a native `<dialog>` in step with an `open` prop.
 *
 * `showModal()` is what gives Dialog, Drawer and BottomSheet their focus trap,
 * ESC handling and top-layer backdrop for free; this is the one place that
 * calls it, so the three cannot drift on the "already open" guards.
 */
export function useModalDialog(ref: RefObject<HTMLDialogElement | null>, open: boolean): void {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) {
      el.showModal();
    } else if (!open && el.open) {
      el.close();
    }
  }, [ref, open]);
}
